export default {
    consultationPanel: "65vh"
}